import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Route, Routes as ReactRoutes } from "react-router-dom";

import Index from "./Partials/Universal/Dashboard/Index";
import MyProfile from "./Partials/MyProfile/MyProfile";
import Hotels from "./Partials/Universal/Hotels/Hotels";
import RoomBooking from "./Partials/Universal/Hotels/Components/RoomBooking/RoomBooking";
import RoomFacilitesList from "./Partials/Universal/Hotels/Components/RoomFacilitesList/RoomFacilitesList";
import FacilityTag from "./Partials/Universal/Hotels/Components/RoomFacilitesList/FacilityTag";
import ItemsList from "./Partials/Universal/Hotels/Components/ItemsList/ItemsList";
import BookingReport from "./Partials/Universal/Hotels/Components/BookingReport/BookingReport";
import PromocodeList from "./Partials/Universal/Hotels/Components/PromocodeList/PromocodeList";
import Transaction from "./Partials/Universal/Transaction/Transaction";
import BookingList from "./Partials/Universal/RoomBook/Components/BookingList/BookingList";
import CancelList from "./Partials/Universal/RoomBook/Components/CancelList/CancelList";
import BookingReceipt from "./Partials/Universal/RoomBook/Components/BookingList/BookingReceipt";
import RoomCheckout from "./Partials/Universal/RoomBook/Components/RoomCheckout/RoomCheckout";
import RoomStatus from "./Partials/Universal/RoomBook/Components/RoomStatus/RoomStatus";
import FacilitesDetailsList from "./Partials/Universal/RoomFacilites/Components/FacilitesDetailsList/FacilitesDetailsList";
import Checklist from "./Partials/Universal/HouseKeeping/Components/Checklist/Checklist";

import ItemsUnitList from "./Partials/Universal/ItemsManage/Components/ItemsUnitList/ItemsUnitList";

import ItemsCategory from "./Partials/Universal/ItemsManage/Components/ItemsCategory/ItemsCategory";
import ItemsSuppliers from "./Partials/Universal/ItemsManage/Components/ItemsSuppliers/ItemsSuppliers";

import AllSettings from "./Partials/Universal/Personalised/Components/AllSettings/AllSettings";
import PurchaseReports from "./Partials/Reports/Components/PurchaseReports/PurchaseReports";
import Invoice from "./Partials/Reports/Components/PurchaseReports/Components/Invoice";
import StockReport from "./Partials/Reports/Components/StockReport/StockReport";
import BedList from "./Partials/RoomsSettings/Components/BedList/BedList";
import BookingTypeList from "./Partials/RoomsSettings/Components/BookingTypeList/BookingTypeList";
import BookingCommission from "./Partials/RoomsSettings/Components/BookingCommission/BookingCommission";
import ComplementaryList from "./Partials/RoomsSettings/Components/ComplementaryList/ComplementaryList";

import RoomList from "./Partials/RoomsSettings/Components/RoomList/RoomList";
import RoomImages from "./Partials/RoomsSettings/Components/RoomImages/RoomImages";
import IndexHr from "./Hrms/Usual/HRDashboard/IndexHr";
import Hrms from "./Hrms/Usual/HRMS/Hrms";
import AddEmployees from "./Hrms/Usual/HRMS/Components/AddEmployees/AddEmployees";
import LeaveRequest from "./Hrms/Usual/HRMS/Components/LeaveRequest/LeaveRequest";
import EmployeeProfile from "./Hrms/Usual/HRMS/Components/LeaveRequest/Components/EmployeeProfile";
import HrmsEmployeeProfile from "./Hrms/Employees/EmployeeProfile/EmployeeProfile";
import EmployeeLeaveRequest from "./Hrms/Employees/LeaveRequest/LeaveRequest";
import ManagerLeaveRequestView from "./Hrms/Employees/LeaveRequest/ManagerLeaveRequestView";
import AssignedEmployeeList from "./Hrms/Usual/HRMS/Components/AssignedEmployeeList/AssignedEmployeeList";
import Attendance from "./Hrms/Usual/HRMS/Components/Attendance/Attendance";
import EmployeeSalary from "./Hrms/Usual/HRMS/Components/EmployeeSalary/EmployeeSalary";
import PayrollReport from "./Hrms/Usual/HRMS/Components/PayrollReport/PayrollReport";
import EmployeesDepartments from "./Hrms/Usual/HRMS/Components/EmployeesDepartments/EmployeesDepartments";
import ShiftList from "./Hrms/Usual/DutyChanges/Components/ShiftList/ShiftList";
import RosterList from "./Hrms/Usual/DutyChanges/Components/RosterList/RosterList";
import AllEmployees from "./Hrms/Employees/AllEmployees/AllEmployees";
import EmployeeLoan from "./Hrms/Employees/EmployeeLoan/EmployeeLoan";
import EmployeeAppraisal from "./Hrms/Employees/EmployeeAppraisal/EmployeeAppraisal";
import PaySlip from "./Hrms/PayRoll/PaySlip/PaySlip";
import Tuning from "./Tuning/Configuration/Components/Tuning/Tuning";
import CommonSettings from "./Tuning/Configuration/Components/Tuning/Components/CommonSettings/CommonSettings";
import PaymentSettings from "./Tuning/Configuration/Components/Tuning/Components/PaymentSettings/PaymentSettings";
import AccountSettings from "./Tuning/Configuration/Components/Tuning/Components/AccountSettings/AccountSettings";
import RoleAdd from "./Tuning/Configuration/Components/Tuning/Components/RoleAdd/RoleAdd";
import Apps from "./Tuning/Configuration/Components/Tuning/Components/Apps/Apps";
import Inbox from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Inbox/Inbox";
import Chat from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Chat/Chat";
import Calendar from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Calendar/Calendar";
import FileManager from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/FileManager/FileManager";
import Changelog from "./Tuning/Configuration/Components/Tuning/Components/Apps/Components/Changelog/Changelog";
import PermissionList from "./Tuning/RoleManagement/PermissionList/PermissionList";
import RolePermission from "./Tuning/RoleManagement/RolePermission/RolePermission";
import RoleList from "./Tuning/RoleManagement/RoleList/RoleList";
import RoleAssign from "./Tuning/RoleManagement/RoleAssign/RoleAssign";
import RoleAccess from "./Tuning/RoleManagement/RoleAccess/RoleAccess";
import AboutUs from "./Tuning/FrontPages/AboutUs/AboutUs";
import ContactUs from "./Tuning/FrontPages/ContactUs/ContactUs";
import PrivacyPolicy from "./Tuning/FrontPages/PrivacyPolicy/PrivacyPolicy";
import TermsConditions from "./Tuning/FrontPages/TermsConditions/TermsConditions";
import Blog from "./Tuning/Application/Blog/Blog";
import BlogDetail from "./Tuning/Application/BlogDetail/BlogDetail";
import SearchPage from "./Tuning/Pages/SearchPage/SearchPage";
import RoomTariff from "./Partials/Universal/RoomBook/Components/RoomTariff/RoomTariffList";
import AddDestination from "./Partials/Universal/TouristFootfall/Components/Destination/Destination";
import DestinationList from "./Partials/Universal/TouristFootfall/Components/Destination/DestinationList";
import FootfallList from "./Partials/Universal/TouristFootfall/Components/Footfall/FootfallList";
import FootfallAdd from "./Partials/Universal/TouristFootfall/Components/Footfall/FootfallAdd";
import UnitWiseOccList from "./Partials/Universal/Reports/Components/UnitWiseOcc/UnitWiseOccList";
import HotelDetails from "./Partials/Universal/Hotels/Components/HotelDetails";
import HotelBlockingForm from "./Partials/Universal/Hotels/Components/RoomBlocking/RoomBlocking";
import BlockingList from "./Partials/Universal/RoomBook/Components/BlockingList/BlockingList";
import SettlementBlock from "./Partials/Universal/RoomBook/Components/BlockingList/SettlementBlock";
import SettlementDetailsView from "./Partials/Universal/RoomBook/Components/BlockingList/SettlementDetailsView";
import CancelledBookings from "./Partials/Universal/RoomBook/Components/CancelList/CancelledBookings";
import PartialCancelList from "./Partials/Universal/RoomBook/Components/PartialCancelList/PartialCancelList";
import FullCancelList from "./Partials/Universal/RoomBook/Components/FullCancelList/FullCancelList";
import RefundList from "./Partials/Universal/RoomBook/Components/RefundList/RefundList";
import PartialDayCancellation from "./Partials/Universal/RoomBook/Components/PartialDayCancellation/PartialDayCancellation";
import BookingFailed from "./Partials/Universal/Hotels/Components/BookingFailed";
import BookingSuccess from "./Partials/Universal/Hotels/Components/BookingSuccess";
import AdvanceBookingsList from "./Partials/Universal/Hotels/Components/AdvanceBookings/AdvanceBookingsList";
import RescheduleList from "./Partials/Universal/Hotels/Components/Reschedule/RescheduleList";
import RaiseRescheduleBooking from "./Partials/Universal/Hotels/Components/Reschedule/RaiseRescheduleBooking";
import PropertiesAdd from "./Partials/Universal/Properties/Components/PropertiesAdd";
import PropertiesList from "./Partials/Universal/Properties/Components/PropertiesView";
import UploadDocuments from "./Partials/Universal/RoomBook/Components/UploadDocuments/UploadDocuments";
import RoomTag from "./Partials/Universal/TagHotelRooms/Components/RoomTag";
import DateWiseOccList from "./Partials/Universal/Reports/Components/DateWiseOcc/DateWiseOccList";
import UnitWiseOccView from "./Partials/Universal/Reports/Components/UnitWiseOcc/UnitWiseOccView";
import UnitWiseOccView1 from "./Partials/Universal/Reports/Components/UnitWiseOcc/UnitWiseOccView1";
import OnlineHBooking from "./Partials/Universal/Reports/Components/OnlineHBooking/OnlineHBookingList";
import Cancellation from "./Partials/Universal/RoomBook/Components/BookingList/Cancellation";
import ReschedulePage from "./Page/ReschedulePage";
import MediaUploadDocuments from "./Partials/Universal/MediaUpload/components/MediaUploadDocuments";
import TodayCheckInList from "./Partials/Universal/Reports/Components/TodayCheckIn/TodayCheckInList";
import NoticeAdminDashboard from "./Partials/Universal/Hotels/Components/Notice/Notices";
import TendersAdminDashboard from "./Partials/Universal/Tender/Tenders";
import PasswordReset from "./Tuning/Pages/Authentication/PasswordReset";
import ProtectedRoute from "./routes/ProtectedRoute";
import HotelWiseMonthlyOccList from "./Partials/Universal/Reports/Components/HotelWiseMonthlyOccupancy/HotelWiseMonthlyOccList";
import LeaveReports from "./Hrms/Usual/HRMS/Components/LeaveRequest/LeaveReports";
import TourBookingList from "./Partials/Universal/Reports/Components/Tour/TourBookingList";
import MediaVideoManager from "./Partials/Universal/UploadVideo/components/MediaVideoManager";
import HomepageBannerManager from "./Partials/Universal/UploadVideo/components/HomepageBannerManager";
import AdminTours from "./Partials/Universal/TourPackage/components/AdminTours";
import EventContentManager from "./Partials/Universal/Events/EventContentManager";
import SmsConfig from "./Hrms/Usual/HRMS/Components/LeaveRequest/Components/SmsConfig";
import LeaveCancellationRequest from "./Hrms/Usual/HRMS/Components/LeaveRequest/LeaveCancellationRequest";
import OrgStructureManager from "./Partials/Universal/OrganizationalStructure/components/OrgStructureManager";
import HotelStaffsLeaveView from "./Hrms/Usual/HRMS/Components/LeaveRequest/Components/AdminManagerLeaveView";
import ServiceRecordList from "./Hrms/ServiceRecord/components/ServiceRecordList";
import ServiceRecordDetail from "./Hrms/ServiceRecord/components/ServiceRecordDetail";
import CreateThread from "./Hrms/ServiceRecord/components/CreateThread";
import MenuList from "./Tuning/RoleManagement/MenuList/MenuList";
import TodayBookingRevenueList from "./Partials/Universal/Reports/Components/TodayBookingRevenue/TodayBookingRevenueList";
import DailyRoomOccupancy from "./Partials/Universal/Reports/Components/DailyRoomOccupancy/DailyRoomOccupancy";
import ItemCategory from "./Partials/Universal/PropertyManage/Components/ItemCategory";
import ItemSubCategory from "./Partials/Universal/PropertyManage/Components/ItemSubCategory";
import ItemMaster from "./Partials/Universal/PropertyManage/Components/ItemMaster";
import RequestIndent from "./Partials/Universal/PropertyManage/Components/RequestIndent";
import DispatchIndent from "./Partials/Universal/PropertyManage/Components/DispatchIndent";
import ReceiveIndent from "./Partials/Universal/PropertyManage/Components/ReceiveIndent";
import ItemStock from "./Partials/Universal/PropertyManage/Components/ItemStock";
import RequestReport from "./Partials/Universal/InvManageReports/Components/RequestReport";
import DispatchReport from "./Partials/Universal/InvManageReports/Components/DispatchReport";
import ReceiveReport from "./Partials/Universal/InvManageReports/Components/ReceiveReport";
import InventoryReport from "./Partials/Universal/InvManageReports/Components/InventoryReport";
import UnitStockReport from "./Partials/Universal/InvManageReports/Components/UnitStockReport";
import CommonReportLayout from "./Partials/Universal/InvManageReports/Components/CommonReportLayout";
import MonthlyStockReport from "./Partials/Universal/InvManageReports/Components/MonthlyWiseReport";
import PaymentReportList from "./Partials/Universal/Reports/Components/PaymentReport/PaymentReportList";
import PropertyNetRevenueList from "./Partials/Universal/Reports/Components/PropertyNetRevenue/PropertyNetRevenueList";
import ConsolidatedSettlementSummaryList from "./Partials/Universal/Reports/Components/ConsolidatedSettlementSummary/ConsolidatedSettlementSummaryList";
import RedisLogs from "./Partials/Universal/RedisLogs/RedisLogs";
import Logs from "./Partials/Universal/Logs/Logs";
import NoPageFound from "./Tuning/Pages/Authentication/NoPageFound";
import WebAnalytics from "./Partials/Universal/WebAnalytics/WebAnalytics";
import CheckAvailability from "./Partials/Universal/Hotels/Components/CheckAvailibilty/CheckAvailibilty";
import TaxValueManagement from "./Partials/Universal/RoomBook/Components/TaxValueManagements/TaxValueManagement";
import TaxTypeMaster from "./Partials/Universal/RoomBook/Components/TaxValueManagements/TaxTypeMaster";
import SubTaxTypeMaster from "./Partials/Universal/RoomBook/Components/TaxValueManagements/SubTaxTypeMaster";
import CheckoutRevenueList from "./Partials/Universal/Reports/Components/Checkoutbookingrevenuereport/CheckoutbookingrevenuereportList";
import BreakfastManagement from "./Partials/Universal/BreakfastManagement/BreakfastManagement";

const Routes = () => {
  const { user } = useSelector((state) => state.auth);
  const customerId = user?.user?.customerId;
  const isAdmin = Number(customerId) === 1;

  return (
    <ReactRoutes>
      {/* For Hotels Tab */}
      <Route exact path="/" element={<Index />} />
      <Route exact path="/index" element={<Index />} />
      <Route exact path="/my-profile" element={<MyProfile />} />
      {/* <Route exact path="/hotels" element={<Hotels/>} /> */}
      <Route exact path="/hotels/:id" element={<HotelDetails />} />
      <Route exact path="/room-booking" element={<RoomBooking />} />
      <Route exact path="/check-availability" element={<CheckAvailability />} />
      <Route exact path="/block-room-history" element={<BlockingList />} />
      <Route exact path="/facility" element={<RoomFacilitesList />} />
      <Route exact path="/facility-tag" element={<FacilityTag />} />
      <Route exact path="/tour-list" element={<TourBookingList />} />
      <Route exact path="/tagRoomConfig" element={<RoomTag />} />
      {/* <Route exact path="/personalised-jacuzzi" element={<JacuzziBooking/>} /> */}
      <Route exact path="/booking-report" element={<BookingReport />} />
      {/* <Route exact path="/promocode-list" element={<PromocodeList/>} /> */}
      {/* <Route exact path="/transaction" element={<Transaction/>} /> */}
      <Route exact path="/room-booking-list" element={<BookingList />} />
      <Route
        exact
        path="/today-booking-list"
        element={<BookingList isTodayOnly={true} />}
      />
      {/* <Route exact path="/checkin-out" element={<RoomCheckout/>} /> */}
      <Route exact path="/room" element={<RoomStatus />} />
      <Route exact path="/tariff" element={<RoomTariff />} />
      <Route exact path="/upload-document" element={<UploadDocuments />} />
      <Route
        exact
        path="/facilites-details"
        element={<FacilitesDetailsList />}
      />
      {/* <Route exact path="/room-size" element={<RoomSize/>} /> */}
      {/* <Route exact path="/housekeeping-roomcleaning" element={<RoomCleaning/>} /> */}
      {/* <Route exact path="/housekeeping-checklist" element={<Checklist/>} />
     <Route exact path="/items-unit-list" element={<ItemsUnitList/>} /> */}
      {/* <Route exact path="/items-destroyed-list" element={<ItemsDestroyed/>} /> */}
      {/* <Route exact path="/items-category-list" element={<ItemsCategory/>} /> */}
      <Route exact path="/online-booking" element={<OnlineHBooking />} />
      {/* <Route exact path="/items-suppliers-list" element={<ItemsSuppliers/>} /> */}
      <Route exact path="/properties" element={<PropertiesAdd />} />
      <Route exact path="/properties-list" element={<PropertiesList />} />
      {/* <Route exact path="/personalised-pedicure" element={<Pedicure/>} />
       <Route exact path="/purchase-report" element={<PurchaseReports/>} /> */}
      {/* <Route exact path="/invoice" element={<Invoice/>} /> */}
      {/* <Route exact path="/stock-report" element={<StockReport/>} /> */}
      {/* <Route exact path="/bed-list" element={<BedList/>} /> */}
      <Route exact path="/booking-type-list" element={<BookingTypeList />} />
      {/* <Route exact path="/commission-list" element={<BookingCommission/>} /> */}
      {/* <Route exact path="/complementary-list" element={<ComplementaryList/>} /> */}
      <Route exact path="/destination" element={<AddDestination />} />
      <Route exact path="/destination-list" element={<DestinationList />} />
      {/* <Route exact path="/footfall" element={<FootfallAdd/>} /> */}
      {/* <Route exact path="/footfall-list" element={<FootfallList/>} /> */}
      <Route
        exact
        path="/booking-view/:P_intBookingID"
        element={<BookingReceipt />}
      />
      <Route exact path="/cancel-history/" element={<CancelList />} />
      <Route exact path="/unitwise-occ/" element={<UnitWiseOccList />} />
      <Route exact path="/datewise-occ" element={<DateWiseOccList />} />
      <Route
        exact
        path="/date-wise-room-occupancy-summary"
        element={<DailyRoomOccupancy />}
      />
      <Route
        exact
        path="/hotelWiseMonthly-occ"
        element={<HotelWiseMonthlyOccList />}
      />
      <Route exact path="/room-blocking" element={<HotelBlockingForm />} />
      <Route exact path="/notice" element={<NoticeAdminDashboard />} />
      <Route exact path="/tender" element={<TendersAdminDashboard />} />
      <Route exact path="/event-content" element={<EventContentManager />} />
      {/*<Route exact path="/video-upload" element={<MediaUploadVideo />} />*/}
      <Route path="/video-upload" element={<MediaVideoManager />} />
      <Route path="/home-banner" element={<HomepageBannerManager />} />
      <Route path="/org-structure" element={<OrgStructureManager />} />
      <Route
        exact
        path="/settlement-block/:ReleaseId"
        element={<SettlementBlock />}
      />
      <Route
        exact
        path="/view-settlement_details/:ReleaseId"
        element={<SettlementDetailsView />}
      />
      <Route exact path="/cancelled-bookings" element={<CancelledBookings />} />
      <Route
        exact
        path="/partial-cancel-list"
        element={<PartialCancelList />}
      />
      <Route exact path="/full-cancel-list" element={<FullCancelList />} />
      <Route exact path="/refund-list" element={<RefundList />} />
      <Route
        exact
        path="/partial-day-cancellation"
        element={<PartialDayCancellation />}
      />
      <Route exact path="/booking-failed" element={<BookingFailed />} />
      <Route
        exact
        path="/booking-rescheduled-list"
        element={<RescheduleList />}
      />
      <Route
        exact
        path="/raise-reschedule-booking"
        element={<RaiseRescheduleBooking />}
      />
      <Route path="/booking-success/:orderId" element={<BookingSuccess />} />
      <Route path="/booking/advance" element={<AdvanceBookingsList />} />
      <Route
        exact
        path="/unitwise-occ/:hotelId"
        element={<UnitWiseOccView />}
      />
      <Route path="/cancellation/:P_intBookingID" element={<Cancellation />} />
      <Route path="/reschedule/:bookingRefNo" element={<ReschedulePage />} />
      <Route path="/today-check-in-report" element={<TodayCheckInList />} />
      <Route
        path="/today-booking-revenue-report"
        element={<TodayBookingRevenueList />}
      />
      <Route
        path="/payment-report"
        element={isAdmin ? <PaymentReportList /> : <Navigate to="/" replace />}
      />
      <Route
        path="/property-net-revenue"
        element={
          isAdmin ? <PropertyNetRevenueList /> : <Navigate to="/" replace />
        }
      />
      <Route
        path="/consolidated-settlement-summary"
        element={
          isAdmin ? (
            <ConsolidatedSettlementSummaryList />
          ) : (
            <Navigate to="/" replace />
          )
        }
      />
      <Route path="/redis-logs" element={<RedisLogs />} />
      <Route path="/http-audit-logs" element={<Logs />} />
      <Route path="/web-analytics" element={<WebAnalytics />} />
      <Route path="/admin/tour" element={<AdminTours />} />
      <Route path="/item-category" element={<ItemCategory />} />
      <Route path="/item-subcategory" element={<ItemSubCategory />} />
      <Route path="/item-master" element={<ItemMaster />} />
      <Route path="/request" element={<RequestIndent />} />
      <Route path="/dispatch" element={<DispatchIndent />} />
      <Route path="/receive" element={<ReceiveIndent />} />
      <Route path="/itemStock" element={<ItemStock />} />
      <Route path="/reports/request" element={<RequestReport />} />
      <Route path="/reports/dispatch" element={<DispatchReport />} />
      <Route path="/reports/receive" element={<ReceiveReport />} />
      <Route path="/reports/inventory" element={<InventoryReport />} />
      <Route path="/reports/unit-stock" element={<UnitStockReport />} />
      <Route path="/reports/monthly-stock" element={<MonthlyStockReport />} />
      <Route path="/tax-value-management" element={<TaxValueManagement />} />
      <Route path="/tax-type-master" element={<TaxTypeMaster />} />
      <Route path="/sub-tax-type-master" element={<SubTaxTypeMaster />} />
      <Route
        path="/checkout-booking-revenue-report"
        element={<CheckoutRevenueList />}
      />
      <Route path="/breakfast-management" element={<BreakfastManagement />} />
      {/* For Hrms Tab */}
      <Route
        exact
        path="/hrms"
        element={
          <ProtectedRoute>
            <Hrms />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/hrms/my-profile"
        element={
          <ProtectedRoute>
            <HrmsEmployeeProfile />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/hrms/leave-request"
        element={
          <ProtectedRoute>
            <EmployeeLeaveRequest />
          </ProtectedRoute>
        }
      />
      <Route
        exact
        path="/hrms/staff-leave-requests"
        element={
          <ProtectedRoute>
            <ManagerLeaveRequestView />
          </ProtectedRoute>
        }
      />
      // HRMS Access controlled routes
      <Route exact path="/employees-add" element={<AddEmployees />} />
      <Route exact path="/employees-leave" element={<LeaveRequest />} />
      <Route
        exact
        path="/HotelStaff-leave-record"
        element={<HotelStaffsLeaveView />}
      />
      <Route
        exact
        path="/employees-leave-cancellation"
        element={<LeaveCancellationRequest />}
      />
      <Route exact path="/employees-leave-report" element={<LeaveReports />} />
      <Route exact path="/management-profile-config" element={<SmsConfig />} />
      <Route exact path="/employee-profile" element={<EmployeeProfile />} />
      <Route path="/password-reset" element={<PasswordReset />} />
      // For Service Record
      <Route path="/service-record" element={<ServiceRecordList />} />
      <Route path="/service-record/:id" element={<ServiceRecordDetail />} />
      <Route path="/service-record/new" element={<CreateThread />} />
      // For RBAC
      <Route exact path="/permission-list" element={<PermissionList />} />
      <Route exact path="/menu-list" element={<MenuList />} />
      <Route
        exact
        path="/role-permission/:roleId"
        element={<RolePermission />}
      />
      <Route exact path="/role-list" element={<RoleList />} />
      <Route exact path="/role-access-list" element={<RoleAccess />} />
      <Route exact path="/role-assign/:userId" element={<RoleAssign />} />
      <Route
        exact
        path="/duty-assigned-list"
        element={<AssignedEmployeeList />}
      />
      <Route exact path="/employees-attendance" element={<Attendance />} />
      <Route
        exact
        path="/payroll-employee-salary"
        element={<EmployeeSalary />}
      />
      <Route exact path="/payroll-report" element={<PayrollReport />} />
      <Route
        exact
        path="/employees-departments"
        element={<EmployeesDepartments />}
      />
      <Route exact path="/duty-shift-list" element={<ShiftList />} />
      <Route exact path="/duty-roster-list" element={<RosterList />} />
      <Route exact path="/employees-all" element={<AllEmployees />} />
      {/* <Route exact path="/index-hr" element={<IndexHr/>} />
     
     
      <Route exact path="/employees-loan" element={<EmployeeLoan/>} />
      <Route exact path="/employees-appraisal" element={<EmployeeAppraisal/>} />
      <Route exact path="/payroll-payslip" element={<PaySlip/>} /> */}
      {/* For Tuning Tab */}
      <Route exact path="/tuning" element={<Tuning />} />
      {/* <Route exact path="/common-settings" element={<CommonSettings/>} /> */}
      {/* <Route exact path="/payment-set" element={<PaymentSettings/>} /> */}
      {/* <Route exact path="/accounts-setting" element={<AccountSettings/>} /> */}
      {/* <Route exact path="/role-add" element={<RoleAdd/>} /> */}
      {/* <Route exact path="/app" element={<Apps/>} /> */}
      {/* <Route exact path="/inbox" element={<Inbox/>} /> */}
      {/* <Route exact path="/chat" element={<Chat />} />
      <Route exact path="/calendar" element={<Calendar />} />
      <Route exact path="/filemanager" element={<FileManager />} />
      <Route exact path="/changelog" element={<Changelog />} />

      <Route exact path="/about-us" element={<AboutUs />} />
      <Route exact path="/contact-us" element={<ContactUs />} />
      <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route exact path="/terms-conditions" element={<TermsConditions />} />
      <Route exact path="/blog" element={<Blog />} />
      <Route exact path="/blog-detail" element={<BlogDetail />} />
      <Route exact path="/search" element={<SearchPage />} /> */}
      <Route
        exact
        path="/hotel-booking-details/:P_HotelID"
        element={<UnitWiseOccView1 />}
      />
      <Route
        exact
        path="/hotel-booking-details/:P_HotelID/:checkinDate"
        element={<UnitWiseOccView1 />}
      />
      <Route exact path="/media-upload" element={<MediaUploadDocuments />} />
      <Route path="*" element={<NoPageFound />} />
    </ReactRoutes>
  );
};

export default Routes;
